import { z } from 'zod';

export const DatabaseWritebackSimpleMetrics = z.object({
  totalAttempted: z.number(),
  succeeded: z.number(),
  failed: z.number(),
  skipped: z.number(),
});

export type DatabaseWritebackSimpleMetrics = z.infer<
  typeof DatabaseWritebackSimpleMetrics
>;

export const DatabaseRunMetrics = z.object({
  numberOfCandidatesInRevisionIndex: z.number(),
  numberOfCandidatesWithHiringScore: z.number(),
  distributionOfHiringScore: z.array(
    z.object({
      hiringScore: z.number(),
      numberOfCandidates: z.number(),
    }),
  ),
  hiringScoreWritebackMetrics: DatabaseWritebackSimpleMetrics,
  stageChangeWritebackMetrics: DatabaseWritebackSimpleMetrics,
});

export type DatabaseRunMetrics = z.infer<typeof DatabaseRunMetrics>;
